export default function initInvisibleLinks() : void {
    const $invisibleLinks = document.querySelectorAll<HTMLElement>('[data-invisible-link]');

    $invisibleLinks.forEach($invisibleLink => {
        new InvisibleLink($invisibleLink);
    });
}

/**
 * Make link invisible for page readers
 * 
 * Usage:
 * <span data-invisible-link data-url="https://domain.fr" data-target="_self">Invisible link</span>
 */
class InvisibleLink {
    constructor($link: HTMLElement) {
        const url = $link.dataset.url;
        const target = $link.dataset.target || '_self';

        if (!url) {
            console.error('Attribute data-url must be set.', $link);
            return;
        }

        $link.addEventListener('click', () => {
            window.open(url, target);
        });
    }
}
